import { FC } from 'react';

import { Box, RadioProps } from '@bonusly/design-system';

export const RadioButton: FC<RadioProps> = ({ isChecked, ...rest }) => {
	return (
		<Box
			_checked={{
				_before: {
					bg: 'blue.500',
					borderRadius: 'full',
					content: '""',
					display: 'block',
					h: 4,
					w: 4,
				},
				alignItems: 'center',
				bg: 'white',
				borderColor: 'blue.500',
				display: 'flex',
				justifyContent: 'center',
			}}
			_disabled={{
				bg: 'gray.25',
				borderColor: 'gray.400',
			}}
			bg="gray.25"
			borderColor="gray.250"
			borderRadius="full"
			borderStyle="solid"
			borderWidth="1px"
			h={6}
			w={6}
			{...(isChecked && {
				'data-checked': true,
			})}
			{...rest}
		/>
	);
};
